import React, { useState } from 'react';
import AWS from 'aws-sdk';
import { Zoom, Slide, Flip, ToastContainer, toast } from 'react-toastify';
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import apiService from '../providers/ApiService';

AWS.config.update({
  region: 'eu-west-1' // Replace with your region
});

export default function AuthComponent() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [gender, setGender] = useState('');
  const [dob, setDob] = useState('');
  const [confirmationCode, setConfirmationCode] = useState('');
  const [isSignUpComplete, setIsSignUpComplete] = useState(false);

  const signUp = async () => {
    const cognito = new AWS.CognitoIdentityServiceProvider();
    const params = {
      ClientId: '4245qg8nfr209bakgtj7vogai4',
      Username: email,
      Password: password,
      UserAttributes: [
        { Name: 'email', Value: email },
        { Name: 'name', Value: firstName },
        { Name: 'family_name', Value: lastName },
        { Name: 'gender', Value: gender },
        { Name: 'birthdate', Value: dob },
        { Name: 'custom:isAdmin', Value: 'false' }
      ]
    };

    try {
      await cognito.signUp(params).promise();
      toast.success('Please check your emails for a confirmation code');
      setIsSignUpComplete(true);
    } catch (err) {
      toast.error(
        'Sign-up failed: ' +
          'Password must contain at least 8 characters, including uppercase, lowercase, and numbers.'
      );
    }
  };

  const confirmSignUp = async () => {
    const cognito = new AWS.CognitoIdentityServiceProvider();
    const params = {
      ClientId: '4245qg8nfr209bakgtj7vogai4',
      Username: email,
      ConfirmationCode: confirmationCode
    };

    try {
      await cognito.confirmSignUp(params).promise();

      // For this specific endpoint, we'll use fetch directly since the user isn't authenticated yet
      // and our ApiService requires authentication
      const response = await fetch(
        'https://rxzycbkuv7.execute-api.eu-west-1.amazonaws.com/dev/user',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ email, firstName, lastName, gender, dob })
        }
      );

      if (!response.ok) {
        throw new Error('Failed to store user details');
      }

      toast.success('Account creation successful');

      window.location.href = '/sign-in'; // Adjust as needed
    } catch (err) {
      toast.error('Something went wrong... ' + err.message);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 10, textAlign: 'center', pt: { xs: 4, sm: 8 } }}>
      {!isSignUpComplete ? (
        <>
          <Typography variant="h4" gutterBottom>
            Sign Up
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              label="First Name"
              variant="outlined"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              fullWidth
            />
            <TextField
              label="Last Name"
              variant="outlined"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              fullWidth
            />
            <TextField
              label="Date of Birth"
              type="date"
              variant="outlined"
              value={dob}
              onChange={(e) => setDob(e.target.value)}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label="Email"
              variant="outlined"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
            />
            <TextField
              label="Password"
              variant="outlined"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
            />
            <FormControl fullWidth>
              <InputLabel>Gender</InputLabel>
              <Select value={gender} onChange={(e) => setGender(e.target.value)}>
                <MenuItem value="male">Male</MenuItem>
                <MenuItem value="female">Female</MenuItem>
                <MenuItem value="other">Other</MenuItem>
              </Select>
            </FormControl>
            <Button variant="contained" color="primary" onClick={signUp}>
              Sign Up
            </Button>
          </Box>
        </>
      ) : (
        <>
          <Typography variant="h5" gutterBottom>
            Confirm Sign Up
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              label="Confirmation Code"
              variant="outlined"
              value={confirmationCode}
              onChange={(e) => setConfirmationCode(e.target.value)}
              fullWidth
            />
            <Button variant="contained" color="secondary" onClick={confirmSignUp}>
              Confirm Sign Up
            </Button>
          </Box>
        </>
      )}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={false}
        theme="colored"
        transition={Slide}
      />
    </Container>
  );
}
